import { Link, useLocation } from 'react-router-dom'
import { twJoin } from 'tailwind-merge'

import { AccountIcon, TasksIcon, StoreIcon } from '@components/navbar/icons'
import { useCurrentStoreId } from '@hooks/useCurrentStore'
import { useScan } from '@hooks/useScan.ts'
import { useDayLink } from '@hooks/useSelectedDay'
import useTypedTranslation from '@hooks/useTypedTranslation'
import { cx } from '@utils/cx'
import { routesFactory } from '@utils/routes.ts'

function MobileNavigation() {
  const { pathname } = useLocation()
  const { t } = useTypedTranslation()
  const storeId = useCurrentStoreId()
  const { pathParam: scanId } = useScan()
  const dayLink = useDayLink()

  const navClasses = twJoin(
    'z-50 flex h-18 w-full flex-row items-center justify-around border-border-secondary bg-white',
    'shadow-[0px_1px_8px_0px_#00000066]'
  )

  function isPathActive(path: string) {
    return pathname.endsWith(path)
  }

  const getLinkClasses = (path: string) =>
    cx(
      'relative flex h-full flex-col items-center justify-center gap-1 text-xs font-medium transition',
      isPathActive(path) ? 'text-text-primary' : 'text-text-secondary'
    )

  const activeMarker = <div className="absolute top-0 h-1 w-[20px] rounded-b-lg bg-brand-primary"></div>

  return (
    <nav className={navClasses} style={{ height: 'var(--mobile-navbar-height)' }}>
      <Link to={dayLink(routesFactory.productFinder(storeId, scanId))} className={getLinkClasses('product-finder')}>
        {isPathActive('product-finder') && activeMarker}
        <StoreIcon />
        {t('productFinder.mobileTitle')}
      </Link>

      <Link to={dayLink(routesFactory.tasks(storeId, scanId))} className={getLinkClasses('out-of-shelf-list')}>
        {isPathActive('out-of-shelf-list') && activeMarker}
        <TasksIcon />
        {t('todoList.mobileTitle')}
      </Link>

      <Link to={dayLink(routesFactory.account(storeId, scanId))} className={getLinkClasses('account')}>
        {isPathActive('account') && activeMarker}
        <AccountIcon />
        {t('account.mobileTitle')}
      </Link>
    </nav>
  )
}

export default MobileNavigation
